<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import AddingSalesRepHelpModal from "@shared/svelte/Components/AddingSalesRepHelpModal.svelte";
  import { salesRepNames } from "@shared/svelte/Modules/SalesRepListService";
  import type { Distributor } from "@shared/types/Distributor";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import DistributorAccountNumberHelpModal from "@shared/svelte/Components/DistributorAccountNumberHelpModal.svelte";
  import type {
    RetailerDistributor,
    RetailerDistributorSummary,
  } from "@shared/types/RetailerDistributor";
  import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { snakeCase } from "lodash";

  export let retailerDistributor: RetailerDistributor | RetailerDistributorSummary = null;
  export let distributor: Distributor;
  export let asButton = false;
  export let maxReps = 2;
  export let source: string = "";

  const dispatch = createEventDispatcher();
  const { trackClick } = EventTracking;

  function clickEvent() {
    let eventName = `${snakeCase(ctaText)}_button`;
    if (source) {
      eventName = `${source}_${eventName}`;
    }
    trackClick(eventName);
    dispatch("openConnectDistributorModal", {
      ...distributor,
      account_number: retailerDistributor?.account_number || distributor.account_number,
    });
    dispatch(eventName);
  }

  let showAddingSalesRepHelpModal = false;
  let showAccountNumberHelpModal = false;

  const showAccountNumberEntry = stagedRolloutCheck(
    "connect_distributor_modal_manual_account_number",
  );

  const showModal = () => {
    trackClick("distributor_catalog_why_link");
    if (needsAccountNumber) {
      showAccountNumberHelpModal = true;
    } else {
      showAddingSalesRepHelpModal = true;
    }
  };

  let needsAccountNumber: boolean;
  let accountNumberText: string;
  let ctaText: string;
  $: {
    needsAccountNumber =
      showAccountNumberEntry &&
      distributor.requires_account_number &&
      !distributor.is_rolling_out_integrated_orders &&
      !(retailerDistributor?.account_number || distributor.account_number);
    accountNumberText =
      distributor?.id === VT_802_SPIRITS_DISTRIBUTOR_ID ? "Connect Account" : "Add account number";
    ctaText = needsAccountNumber ? accountNumberText : "Add sales reps";
  }
</script>

<style>
  .sales-reps p {
    --max-width: none;
  }

  @media screen and (max-width: 700px) {
    .sales-reps p {
      --max-width: 35ch;
    }
  }
</style>

<div class="fizz-flex-row fizz-text-medium sales-reps">
  {#if !needsAccountNumber && ((distributor.sales_reps && distributor.sales_reps.length) || distributor.no_sales_reps_needed)}
    <p class="fizz-truncate">
      <strong>My sales reps:</strong>
      <a href="/settings/accounts">{salesRepNames(distributor, maxReps)}</a>
    </p>
  {:else if asButton}
    <button class="fizz-button-small fizz-button-secondary" on:click={clickEvent}>{ctaText}</button>
    {#if distributor.id !== VT_802_SPIRITS_DISTRIBUTOR_ID}
      <a
        href={"#"}
        class="fizz-text-inherit fizz-text-underline"
        on:click|preventDefault={showModal}
      >
        Why?
      </a>
    {/if}
    <AddingSalesRepHelpModal
      bind:showAddingSalesRepHelpModal
      on:close={() => {
        showAddingSalesRepHelpModal = false;
      }}
    />
    <DistributorAccountNumberHelpModal
      bind:showModal={showAccountNumberHelpModal}
      on:close={() => {
        showAccountNumberHelpModal = false;
      }}
    />
  {:else}
    <a href={"#"} on:click|preventDefault={clickEvent}>{ctaText}</a>
  {/if}
</div>
